import { Chip, ChipProps } from "@mui/material";

export default function MetaChip({ sx, ...props }: ChipProps) {
    return <Chip {...props} color="default" variant="filled" sx={{
        border: 1,
        borderColor: "var(--prm-border)",
        color: "text.secondary",
        backgroundColor: "background.paper",
        ...sx,
    }} />;
}
